import { render, staticRenderFns } from "./MarginConfirmationBlock.vue?vue&type=template&id=4ff0ecd4&scoped=true&"
import script from "./MarginConfirmationBlock.vue?vue&type=script&lang=js&"
export * from "./MarginConfirmationBlock.vue?vue&type=script&lang=js&"
import style0 from "./MarginConfirmationBlock.vue?vue&type=style&index=0&id=4ff0ecd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff0ecd4",
  null
  
)

export default component.exports